import { useTranslation } from 'react-i18next';

export const CustomToastContent = ({
    content,
    translated,
    whiteText,
}: {
    content: string[];
    translated?: boolean;
    whiteText?: boolean;
}) => {
    const { t } = useTranslation('translation');

    const translateElement = (element: string) => {
        if (!translated) return element;
        const str = String(element);

        // Strip common. or errors. prefix if already attached
        const stripped = str.replace(/^(common|errors)\./, '');
        // Clean indexed field paths like devices[0].workHoursList -> workHoursList
        const cleanField = stripped.replace(/.*\[\d+\]\./, '').replace(/^.*\./, '');

        // 1. Try common. with stripped key
        const inCommonStripped = t(`common.${stripped}`);
        if (inCommonStripped !== `common.${stripped}`) return inCommonStripped;

        // 2. Try common. with cleaned field key
        const inCommonClean = t(`common.${cleanField}`);
        if (inCommonClean !== `common.${cleanField}`) return inCommonClean;

        // 3. Try errors. prefix as fallback
        const inErrorsStripped = t(`errors.${stripped}`);
        if (inErrorsStripped !== `errors.${stripped}`) return inErrorsStripped;

        const inErrorsClean = t(`errors.${cleanField}`);
        if (inErrorsClean !== `errors.${cleanField}`) return inErrorsClean;

        // 4. Try direct key
        const direct = t(str);
        if (direct !== str) return direct;

        return str;
    };

    return (
        <div className={`d-flex flex-column justify-content-center w-100 `}>
            {content.map((element, index) => (
                <p className={`${whiteText && 'text-white'} mb-0`} key={index}>
                    {translateElement(element)}
                </p>
            ))}
        </div>
    );
};

